import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip, useTheme } from '@mui/material';
import { DocumentArrowRightRegular } from '@fluentui/react-icons';
import { PageHeader } from '@ui/layout/Layout/components';
import { FiltersDiscardButton } from '@ui/components/common/buttons';
import SSearchInput from '@ui/components/common/SSearchInput';
import IncidentsDataGrid from './components/IncidentsDataGrid';
import useIncidentsStyles from './useIncidentsStyles';
import { useDispatch, useSelector } from 'react-redux';
import { clearFilters, clearIncidents, fetchIncidentExcel, fetchIncidents, setSearch, clearSearch } from '@application/redux/Incidents/incident-slice';
const Incidents = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { saveDocumentButtonStyles } = useIncidentsStyles();
    const [isLoading, setisLoading] = useState(true);
    const dispatch = useDispatch();
    const { incidents, search, pageNumber, pageSize, filteredColumns } = useSelector((state) => state.incidentDetail);
    const [isFilterEnabled, setIsFilterEnabled] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            setisLoading(true);
            try {
                await dispatch(fetchIncidents()).unwrap();
            }
            catch (error) {
            }
            finally {
                setisLoading(false);
            }
        };
        fetchData();
        return () => {
            dispatch(clearIncidents());
        };
    }, [dispatch, search, pageNumber, pageSize, filteredColumns]);
    useEffect(() => {
        return () => {
            dispatch(clearFilters());
            dispatch(clearSearch());
        };
    }, [dispatch]);
    const handleExcelSheetDownload = async () => {
        setisLoading(true);
        dispatch(fetchIncidentExcel())
            .unwrap()
            .then(() => {
            setisLoading(false);
        });
    };
    const handleEnableFilters = () => {
        setIsFilterEnabled(true);
    };
    const DiscardAndCloseFilters = () => {
        setIsFilterEnabled(false);
        dispatch(clearFilters());
    };
    const rows = incidents?.data.data.map((a) => ({
        id: a.id || '',
        systemName: a.systemName || '',
        assetName: a.assetName || '',
        licensePlate: a.licensePlate,
        location: a.location || '',
        locationQuardinates: a.locationQuardinates,
        incidentDate: a.incidentDate,
        score: a.score,
        imageUrl: a.imageUrl || ''
    })) || [];
    const hasChanges = true;
    const hasNewChanges = isFilterEnabled && hasChanges;
    return (_jsxs(React.Fragment, { children: [_jsx(PageHeader, { title: t('Incidents'), icons: _jsx(_Fragment, { children: _jsx(Tooltip, { title: t('ExportIncidents'), placement: 'top', arrow: true, children: _jsx(Button, { size: 'small', variant: 'contained', color: 'primary', sx: saveDocumentButtonStyles, onClick: handleExcelSheetDownload, children: _jsx(DocumentArrowRightRegular, { color: theme.palette.primary.contrastText, fontSize: 20 }) }) }) }), filters: _jsxs(_Fragment, { children: [_jsx(FiltersDiscardButton, { hasNewChanges: hasNewChanges, handleDiscardFilters: DiscardAndCloseFilters, handleShowFilters: handleEnableFilters }), _jsx(SSearchInput, { onChange: (e) => {
                                dispatch(setSearch(e.target.value));
                            } })] }) }), _jsx(IncidentsDataGrid, { handleEnableFilters: handleEnableFilters, showFilters: isFilterEnabled, rows: rows, loading: isLoading, fullHeight: true })] }));
};
export default Incidents;
